import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import WarningIcon from "@material-ui/icons/Warning";
import BugReportIcon from "@material-ui/icons/BugReport";
import SendIcon from "@material-ui/icons/Send";

const useStyles = makeStyles((theme) => ({
  toast: {
    borderRadius: 16,
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 280,
    maxWidth: 360,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    fontFamily: "inherit",
    direction: "rtl",
    animation: "$popIn 0.35s cubic-bezier(0.34,1.56,0.64,1)",
  },
  "@keyframes popIn": {
    "0%": { opacity: 0, transform: "scale(0.7) translateY(20px)" },
    "100%": { opacity: 1, transform: "scale(1) translateY(0)" },
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
  "@keyframes checkPop": {
    "0%": { transform: "scale(0)" },
    "60%": { transform: "scale(1.3)" },
    "100%": { transform: "scale(1)" },
  },
  success: {
    background: "linear-gradient(135deg, #00897B 0%, #26C6A0 100%)",
    color: "#fff",
  },
  info: {
    background: "linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)",
    color: "#fff",
  },
  warning: {
    background: "linear-gradient(135deg, #E65100 0%, #FFA726 100%)",
    color: "#fff",
  },
  error: {
    background: "linear-gradient(135deg, #B71C1C 0%, #EF5350 100%)",
    color: "#fff",
  },
  iconWrap: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.2)",
  },
  iconSuccess: {
    animation: "$checkPop 0.5s cubic-bezier(0.34,1.56,0.64,1) 0.1s both",
    fontSize: 26,
  },
  iconSpin: {
    animation: "$spin 1.2s linear infinite",
    fontSize: 22,
  },
  iconStatic: {
    fontSize: 24,
  },
  textWrap: {
    flex: 1,
  },
  title: {
    fontWeight: 700,
    fontSize: 15,
    lineHeight: 1.3,
    marginBottom: 2,
  },
  subtitle: {
    fontSize: 12,
    opacity: 0.85,
    lineHeight: 1.4,
  },
  closeBtn: {
    background: "none",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    opacity: 0.7,
    fontSize: 18,
    padding: "0 4px",
    lineHeight: 1,
    "&:hover": { opacity: 1 },
  },
}));

const STATUS_CONFIG = {
  received: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
  analyzing: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
  pending_review: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
  fixed: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
  escalated: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
  failed: {
    type: "success",
    icon: "check",
    title: "תודה על המשוב!",
    subtitle: "הצוות שלנו יטפל בזה בהקדם",
    autoHideDuration: 4000,
  },
};

const BugStatusSnackbar = ({ status, open, onClose }) => {
  const classes = useStyles();
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  const renderIcon = () => {
    if (config.icon === "check")
      return <CheckCircleOutlineIcon className={classes.iconSuccess} style={{ fontSize: 26 }} />;
    if (config.icon === "send")
      return <SendIcon className={classes.iconSuccess} style={{ fontSize: 22 }} />;
    if (config.icon === "spin")
      return <BugReportIcon className={classes.iconSpin} />;
    if (config.icon === "warn")
      return <WarningIcon className={classes.iconStatic} />;
    return <ErrorOutlineIcon className={classes.iconStatic} />;
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={config.autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <div className={`${classes.toast} ${classes[config.type]}`}>
        <div className={classes.iconWrap}>{renderIcon()}</div>
        <div className={classes.textWrap}>
          <div className={classes.title}>{config.title}</div>
          <div className={classes.subtitle}>{config.subtitle}</div>
        </div>
        <button className={classes.closeBtn} onClick={onClose}>✕</button>
      </div>
    </Snackbar>
  );
};

export default BugStatusSnackbar;
